import React, { Children } from 'react';

import { PageScrollerAnchor } from '../PageScrollerNavigation';

type Props = Readonly<{
    title?: string | React.ReactNode;
    anchorName?: string;
    removeAnchor?: boolean;
    cardClass?: string;
    headerClass?: string;
    bodyClass?: string;
    children: React.ReactNode;
}>;
export default function Card({
    title = null,
    anchorName = '',
    removeAnchor = false,
    cardClass = '',
    headerClass = '',
    bodyClass = '',
    children,
}: Props) {
    const anchor = anchorName.length > 0 ? anchorName : findAnchorName(title);

    return (
        <div className={`card ${cardClass}`}>
            {(removeAnchor !== true && anchor !== null) && <PageScrollerAnchor name={anchor} />}
            {title !== null && <div className={`card-header ${headerClass}`}>{title}</div>}
            <div className={`card-body ${bodyClass}`}>{children}</div>
        </div>
    );
}

function findAnchorName(node: React.ReactNode | string | null): string | null {
    if (node === null) {
        return null;
    }

    const firstChild = Children.toArray(node).at(0) as React.ReactElement;

    return firstChild?.props?.children ? findAnchorName(firstChild.props.children) : String(firstChild);
}
